import { useMemo } from "react";
import { useFormContext } from "react-hook-form";

import Stack from "@mui/material/Stack";
import { Button, FormSelectField } from "@covertree/ui";
import { IbhsFortifiedCertification } from "@covertree/new-business-graphql";
import {
  FortifiedHomeCertification,
  UnitLevelUnderwritingAnswers,
} from "@covertree/types";
import { sortBasedOnAnotherArr } from "@covertree/utils";

import { UnderwritingQuestionsForm } from "../../../validatorsAndTypes/underwritingQuestions";
import { QuestionModalProps } from "../underwritingQuestions";
import {
  mapIbhsFortifiedCertificationLabel,
  mapQuestionOptionsToFormOptions,
} from "../../../mappings/underwritingQuestionsMaps";

const fortifiedCertificationOptionsOrder = [
  IbhsFortifiedCertification.Bronze,
  IbhsFortifiedCertification.Silver,
  IbhsFortifiedCertification.Gold,
  IbhsFortifiedCertification.SaferLiving,
];

export function StormMitigationFortifiedForm({
  questions,
  closeModal,
}: QuestionModalProps) {
  const { formState, control } = useFormContext<UnderwritingQuestionsForm>();

  const fortifiedCertificationOptions = useMemo(
    () =>
      mapQuestionOptionsToFormOptions<
        IbhsFortifiedCertification,
        FortifiedHomeCertification
      >(
        questions?.[
          UnitLevelUnderwritingAnswers.StormMitigationFortified
        ].options?.filter(
          (value) => value !== IbhsFortifiedCertification.No
        ) as IbhsFortifiedCertification[],
        mapIbhsFortifiedCertificationLabel
      ).sort((item1, item2) =>
        sortBasedOnAnotherArr(
          item1.value,
          item2.value,
          fortifiedCertificationOptionsOrder
        )
      ),
    [questions]
  );
  return (
    <Stack>
      <FormSelectField
        control={control}
        name="stormMitigationFortifiedValue"
        id="stormMitigationFortified"
        dataTestId="stormMitigationFortified"
        options={fortifiedCertificationOptions}
        label="Which certificate do you possess?"
      />
      <Button disabled={!formState.isValid} onClick={closeModal} sx={{ mt: 3 }}>
        Save
      </Button>
    </Stack>
  );
}
